import PropTypes from "prop-types";

import dashHangingUpImage from "@images/dash-hanging-up.png?url";

import "./dash-hanging-up.scss";

export const DashHangingUp = () => {
  return (
    <div className="dash-hanging-up-image">
      <div>
        <svg
          width="100%"
          height="100%"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
        >
          <circle
            cx="50%"
            cy="0"
            r="45%"
            stroke="#089DD4"
            strokeWidth="5"
            strokeDasharray="18 10"
          />
        </svg>
        <img src={dashHangingUpImage} alt="Dash Hanging Up" />
      </div>
    </div>
  );
};

DashHangingUp.propTypes = {
  className: PropTypes.string,
};

DashHangingUp.displayName = "DashHangingUp";
